import React, { Component } from 'react';

// import { API, Auth } from "aws-amplify";

// import { Layout, Menu, Breadcrumb, Icon } from 'antd';
import { Card } from 'antd';
import { PageHeader, Button } from 'antd';

import BrickNewPageComponentContainer from '../../../components/pages/dashboard/bricks/BrickNewPageComponent';

// const { Header, Content, Footer, Sider } = Layout;
// const { SubMenu } = Menu;

class BrickNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  handle_show_all = () => {
    this.props.history.push(`/bricks/list/`);
  }

  handle_new_bricks = () => {
    this.props.history.push(`/bricks/new`);
  }

  render() {
    // console.log(this.state);
    return (

      <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
        <PageHeader
          style={{
            paddingLeft: 0,
            borderBottom: '1px solid rgb(235, 237, 240)',
            marginBottom: 16
          }}
          title="Create New Brick"
        />
        <Card
          style={{ minHeight: 360 }}
          title="Create a New Brick Record via these simple steps"
          extra={[
            <React.Fragment>
              {
                <span>
                  <Button key="1" onClick={this.handle_show_all}>
                    Show All
                  </Button>
                  <Button key="2" disabled onClick={this.handle_new_bricks}>
                    New Bricks
                  </Button>
                </span>
              }
            </React.Fragment>

          ]}
        >
          <div style={{ paddingTop: 24 }}>
            <BrickNewPageComponentContainer />
          </div>
        </Card>
      </div>


    );
  }
}

export default BrickNewPage;
